import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $Locale, $UserAgent } from '@lemon8/web-app-shared/atom';
import { Link } from '@remix-run/react';
import Logo from './assets/logo.svg';
import { Share } from '~/components/share';
import { LegalMenu } from '~/components/legal-menu';
import { LanguageSelector } from '~/components/language-selector';

import './style.scss';

export const Header: FC = () => {
  const { region } = useAtomValue($Locale);
  const { isBot } = useAtomValue($UserAgent);

  return (
    <header>
      {isBot ? (
        <Link to={`/feed/foryou?region=${region}`} target="_blank" className="logo">
          <Logo />
        </Link>
      ) : (
        <div className="logo">
          <Logo />
        </div>
      )}
      <div className="right">
        <Share className="share" />
        <LegalMenu className="menu" />
        <LanguageSelector right={32} className="language_selector" />
      </div>
    </header>
  );
};
